import {requests,sysFileInfoUpload} from "./request"; //引入二次封装的axios
import axios from "axios";

var BASE_URL = "https://www.zupu01.com/api";
//var BASE_URL = "http://192.168.2.8:15610";

export const login = (params) => requests({ url: '/user/login ', method: 'post', data: params });

export const lineChildList = (id) => requests({ url: `${BASE_URL}/genealogybook/pdf/open/lineChildList/${id}`, method: 'get' });
export const treeListDataTree = (data) => requests({ url: `${BASE_URL}/ethnic/treeListDataTree`, method: 'post', data: data });

// 上传文件-个人
export function uploadMy (parameter) {
    return axios({
      url: `${BASE_URL}/genealogybook/v1/public/file/upload`,
      method: 'post',
      data: parameter
    })
  }


// WEBPACK FOOTER //
// ./src/api/index.js